import { render, staticRenderFns } from "./OfficeBiz.vue?vue&type=template&id=5e828322&scoped=true&"
import script from "./OfficeBiz.vue?vue&type=script&lang=js&"
export * from "./OfficeBiz.vue?vue&type=script&lang=js&"
import style0 from "./OfficeBiz.vue?vue&type=style&index=0&id=5e828322&scoped=true&lang=css&"
import style1 from "./OfficeBiz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e828322",
  null
  
)

export default component.exports